import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const FALLBACK_IMG = "https://images.unsplash.com/photo-1705859895765-4b3a5be782c6?auto=format&fit=crop&w=1200&q=70";

export const CATEGORIES = [
  { slug: "politica", name: "Política" },
  { slug: "economia", name: "Economia" },
  { slug: "sociedade", name: "Sociedade" },
  { slug: "desporto", name: "Desporto" },
  { slug: "mundo", name: "Mundo" },
  { slug: "tecnologia", name: "Tecnologia" },
  { slug: "cultura", name: "Cultura" },
  { slug: "saude", name: "Saúde" },
];
export const catName = (slug) => CATEGORIES.find((c) => c.slug === slug)?.name || "Notícias";

export const http = axios.create({ baseURL: API, withCredentials: true });
http.interceptors.request.use((c) => {
  const t = localStorage.getItem("n365-token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const fetchHome = () => http.get("/home").then((r) => r.data);
export const fetchNews = (params) => http.get("/news", { params }).then((r) => r.data);
export const fetchArticle = (id) => http.get(`/news/${id}`).then((r) => r.data);
export const fetchRelated = (id) => http.get(`/news/${id}/related`).then((r) => r.data);
export const fetchSources = () => http.get("/sources").then((r) => r.data);
export const audioUrl = (id) => `${API}/news/${id}/audio`;
export const shareUrl = (id) => `${BACKEND_URL}/api/share/${id}`;
export const imgUrl = (id, w = 640) => `${API}/img/${id}.jpg${w < 1200 ? `?w=${w}` : ""}`;
export const fileUrl = (image) => (image?.startsWith("storage:") ? `${API}/files/${image.slice(8)}` : image);

export const slugify = (s = "") => s.normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 80);
export const articlePath = (a) => `/noticia/${a.id}/${slugify(a.title)}`;

export function timeAgo(iso) {
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "agora mesmo";
  if (s < 3600) return `há ${Math.floor(s / 60)} min`;
  if (s < 86400) return `há ${Math.floor(s / 3600)} h`;
  if (s < 604800) return `há ${Math.floor(s / 86400)} d`;
  return new Date(iso).toLocaleDateString("pt-MZ", { day: "numeric", month: "short", year: "numeric" });
}
export const clock = (iso) => new Date(iso).toLocaleTimeString("pt-MZ", { hour: "2-digit", minute: "2-digit" });

export const readTime = (html = "") => Math.max(1, Math.round(html.replace(/<[^>]+>/g, " ").split(/\s+/).length / 200));

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Ocorreu um erro. Tente novamente.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}
